import React, { useState, useEffect } from "react";
import PersonilTab from "./tabs/PersonilTab";
import SimpleCrudTab from "./tabs/SimpleCrudTab";
import { PageHeader } from "../../components/UI";
import { personelAPI } from "../../utils/api";

const PersonelPage = () => {
  const [tab, setTab] = useState("personil");
  const [kotamaList, setKotamaList] = useState([]);
  const [satminkalList, setSatminkalList] = useState([]);
  const [rambutList, setRambutList] = useState([]);
  const [kulitList, setKulitList] = useState([]);

  useEffect(() => {
    Promise.all([
      personelAPI.getKotama().then(r => setKotamaList(r.data || [])).catch(() => setKotamaList([])),
      personelAPI.getSatminkal().then(r => setSatminkalList(r.data || [])).catch(() => setSatminkalList([])),
      personelAPI.getRambut().then(r => setRambutList(r.data || [])).catch(() => setRambutList([])),
      personelAPI.getKulit().then(r => setKulitList(r.data || [])).catch(() => setKulitList([])),
    ]);
  }, []);

  return (
    <div>
      <PageHeader title="Manajemen Personel" subtitle="Data dan informasi personel TNI AD" />
      <div style={{ display: "flex", gap: 8, marginBottom: 24, borderBottom: "1px solid #E5E7EB" }}>
        <button onClick={() => setTab("personil")} style={{ padding: "12px 16px", borderBottom: tab === "personil" ? "2px solid #2563EB" : "none", color: tab === "personil" ? "#2563EB" : "#6B7280", fontWeight: tab === "personil" ? 600 : 500, border: "none", background: "none", cursor: "pointer" }}>
          Data Personil
        </button>
        <button onClick={() => setTab("crud")} style={{ padding: "12px 16px", borderBottom: tab === "crud" ? "2px solid #2563EB" : "none", color: tab === "crud" ? "#2563EB" : "#6B7280", fontWeight: tab === "crud" ? 600 : 500, border: "none", background: "none", cursor: "pointer" }}>
          Kelola Data
        </button>
      </div>
      <div>
        {tab === "personil" && <PersonilTab kotamaList={kotamaList} satminkalList={satminkalList} rambutList={rambutList} kulitList={kulitList} />}
        {tab === "crud" && (
          <SimpleCrudTab
            title="Kelola Master Data"
            items={[]}
            addFn={async () => {}}
            updFn={async () => {}}
            delFn={async () => {}}
            onRefresh={() => {}}
          />
        )}
      </div>
    </div>
  );
};

export default PersonelPage;
